import Validation from '../lib/validation'

function validate(data, type) {
  const validator = new Validation(data)
  switch (type) {
    case 'update': {
      validator.isRequired('_id', 'ID společnosti je při editaci povinné.')
      validator.isObjectId('_id', 'ID společnosti není ve správném formátu.')
    }
    // no default
  }
  const emailsError =
    'Seznam emailů není ve správném formátu, každý email musí být oddělen čárkou nebo středníkem.'
  validator.isRequired('name', 'Název společnosti je povinný.')
  if (data.drivingLicenseExpirationEmails && data.drivingLicenseExpirationEmails.length) {
    validator.isArrayOfEmails(
      'drivingLicenseExpirationEmails',
      emailsError,
    )
  }
  if (data.medicalExamExpirationEmails && data.medicalExamExpirationEmails.length) {
    validator.isArrayOfEmails(
      'medicalExamExpirationEmails',
      emailsError,
    )
  }
  if (data.adrExpirationEmails && data.adrExpirationEmails.length) {
    validator.isArrayOfEmails(
      'adrExpirationEmails',
      emailsError,
    )
  }
  if (data.trainingExpirationEmails && data.trainingExpirationEmails.length) {
    validator.isArrayOfEmails(
      'trainingExpirationEmails',
      emailsError,
    )
  }

  return validator.validate()
}

export const validateCreate = (data) => validate(data, 'create')
export const validateUpdate = (data) => validate(data, 'update')

export default validate



// WEBPACK FOOTER //
// ./src/common/companies/validations.js